const editing = new Set();
export const RECORD_EDIT_EVENT = "facility-ai-record-edit-state";
export const RECORD_SAVED_EVENT = "facility-ai-record-saved";
const key = ({ companyId, facilityId, resource, recordId }) => `${companyId}:${facilityId}:${resource}:${recordId}`;
export const isRecordEditing = (record) => editing.has(key(record));
export const setRecordEditing = (record, active) => {
  if (active) editing.add(key(record));
  else editing.delete(key(record));
  if (typeof window !== "undefined") window.dispatchEvent(new Event(RECORD_EDIT_EVENT));
};
